import { isFieldValueEmpty } from './is-field-value-empty';
export function isFieldValueValid(
  value: any,
  isRequired: boolean,
  validationValue: any,
  validationType = 'regexp',
): boolean {
  if (isFieldValueEmpty(value) && isRequired) {
    return false;
  }

  if (isFieldValueEmpty(value) && !isRequired) {
    return true;
  }
  if (validationType === 'regexp' && !validationValue) {
    console.error('No regexp found', validationValue);
  }

  if (validationType === 'regexp') {
    const regExp = new RegExp(validationValue, 'i');
    if (!regExp) {
      return true;
    }

    if (!(value + '').match(regExp)) {
      return false;
    }
  }
  return true;
}
